/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { routes } from '@builddocs/data-management'
import { useTestAuth } from '@builddocs/data-management-auth'
import { useToast } from '@builddocs/system'

import { ScreenWrapper } from '../ScreenWrapper/ScreenWrapper'

import styles from './style.module.scss'
import { WhiteBox } from './WhiteBox'

const isDevEnvironment =
  process.env.NODE_ENV === 'development' || process.env.NX_ENV === 'development'

const URL_GK_OSNOVA = isDevEnvironment
  ? process.env.NX_GK_OSNOVA_DEV
  : process.env.NX_GK_OSNOVA

const LoginScreen = () => {
  const { isAuth } = useTestAuth({
    redirectUrlOnSuccess: routes.navigator.base(),
    loginUrl: routes.auth.signIn(),
  })
  const { toast } = useToast()

  const handleRedirect = () => {
    if (URL_GK_OSNOVA) {
      window.location.href = URL_GK_OSNOVA
    } else toast.error.t('auth.message.redirect_failure')
  }

  if (isAuth) return null

  return (
    <ScreenWrapper styles={styles.loginScreen_wrapper}>
      {/*<Box*/}
      {/*  sx={{*/}
      {/*    width: '100%',*/}
      {/*    position: 'fixed',*/}
      {/*    top: 0,*/}
      {/*    height: '56px',*/}
      {/*    minHeight: '56px',*/}
      {/*    display: 'flex',*/}
      {/*    alignItems: 'center',*/}
      {/*    justifyContent: 'space-evenly',*/}
      {/*    zIndex: 1250,*/}
      {/*    bgcolor: '#0034AD',*/}
      {/*    color: 'white',*/}
      {/*    padding: '32px',*/}
      {/*    textAlign: 'center',*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Уважаемые пользователи! Обратите внимание, что в связи с техническими*/}
      {/*  работами наш сервис может работать нестабильно и с задержками ежедневно*/}
      {/*  с 13:00 до 14:00 по московскому времени до 10 декабря.*/}
      {/*  <br />В остальное время все функции сервиса будут доступны. Спасибо за*/}
      {/*  понимание!*/}
      {/*</Box>*/}
      <WhiteBox
        isDevEnvironment={isDevEnvironment}
        onRedirect={handleRedirect}
      />
    </ScreenWrapper>
  )
}

export default LoginScreen
